module.exports = __webpack_public_path__ + "static/nazar_chervinskyy-73997a843a594f74049a34de66ca324d.png";